import { makePersisted } from "@solid-primitives/storage";
import { createSignal } from "solid-js";
import { createStore } from "solid-js/store";
import { isServer } from "solid-js/web";

export type UIStore = ReturnType<typeof createUIService>;

// Bits and bobs for app-wide UI state
// TODO: @andi Refactor the AppUIContext into this service so everything is centralized
export const createUIService = () => {
  const [state, setState] = createStore({
    creditsGateModal: "",
    manageLabelsModal: false,
    processingAssetsGateModal: false,
    processingAssetsGateAction: null as null | (() => unknown),
  });

  const [closedConcepts, setClosedConcepts] = makePersisted(createSignal(false), {
    storage: isServer ? undefined : localStorage,
    name: "chat-related-concepts-closed",
  });

  return {
    conceptsPoweringChat: {
      closed: () => closedConcepts(),
      setClosed: (closed: boolean) => setClosedConcepts(closed),
    },
    creditsGate: {
      isModalOpen: () => state.creditsGateModal !== "",
      description: () => state.creditsGateModal,
      openModal: (description: string) => setState("creditsGateModal", description),
      closeModal: () => setState("creditsGateModal", ""),
    },
    manageLabels: {
      isModalOpen: () => state.manageLabelsModal,
      openModal: () => setState("manageLabelsModal", true),
      closeModal: () => setState("manageLabelsModal", false),
    },
    processingAssetsGate: {
      isModalOpen: () => state.processingAssetsGateModal,
      executeGatedAction: () => state.processingAssetsGateAction?.(),
      // biome-ignore lint/suspicious/noExplicitAny: Type doesn't matter
      openModal: (action?: () => any) => {
        setState("processingAssetsGateAction", () => action ?? null);
        setState("processingAssetsGateModal", true);
      },
      closeModal: () => {
        setState("processingAssetsGateAction", null);
        setState("processingAssetsGateModal", false);
      },
    },
  };
};
